// extracted by mini-css-extract-plugin
export default {"container":"admin_console_container__o3Rsr","quotation_container":"admin_console_quotation_container__hSf54","areas_container":"admin_console_areas_container__s7iQC"};